import { useEffect, useState } from 'react';
import { DictionaryItem, fetchJobs, Job } from '../api/JobsApi';
import { useDebounce } from './useDebounce';

export function useJobs() {
  const [jobs, setJobs] = useState<Job[]>([]);

  const [skills, setSkills] = useState<string[]>([]);
  const [locations, setLocations] = useState<DictionaryItem[]>([]);
  const [types, setTypes] = useState<DictionaryItem[]>([]);

  const [loading, setLoading] = useState<boolean>(false);

  const [filters, setFilters] = useState<{
    location: string[];
    type: string[];
    skills: string[];
  }>({
    location: [],
    type: [],
    skills: [],
  });

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 6,
    pageCount: 1,
    total: 0,
  });

  const debouncedFilters = useDebounce(filters, 300);

  useEffect(() => {
    fetchJobs({
      page: 1,
      pageSize: 1000,
      filters: {
        location: [],
        type: [],
        skills: [],
      },
    }).then(res => {
      const allJobs = res.jobs;

      const locationsMap = new Map<string, DictionaryItem>();
      const typesMap = new Map<string, DictionaryItem>();
      const skillsSet = new Set<string>();

      for (const job of allJobs) {
        if (job.location) {
          locationsMap.set(job.location.code, job.location);
        }

        if (job.type) {
          typesMap.set(job.type.code, job.type);
        }

        for (const skill of job.skills ?? []) {
          skillsSet.add(skill.name);
        }
      }

      setLocations(Array.from(locationsMap.values()));
      setTypes(Array.from(typesMap.values()));
      setSkills(Array.from(skillsSet));
    });
  }, []);

  useEffect(() => {
    setLoading(true);

    fetchJobs({
      page: pagination.page,
      pageSize: pagination.pageSize,
      filters: debouncedFilters,
    }).then(res => {
      setJobs(res.jobs);

      setPagination(prev => ({
        ...prev,
        page: res.pagination.page,
        pageSize: res.pagination.pageSize,
        pageCount: res.pagination.pageCount,
        total: res.pagination.total,
      }));

      setLoading(false);
    });
  }, [pagination.page, pagination.pageSize, debouncedFilters]);

  return {
    jobs,
    skills,
    locations,
    types,
    loading,
    filters,
    setFilters,
    pagination,
    setPagination,
  };
}
